var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.304,
    height: 25.142,
    viewBox: "0 0 38.304 25.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5870be;\n      }\n\n      .cls-2 {\n        fill: #ffaf38;\n      }\n\n      .cls-3 {\n        fill: #e63737;\n      }\n\n      .cls-4 {\n        fill: #fff;\n        font-size: 6px;\n        font-family: Arial-Black, Arial;\n        font-weight: 800;\n        letter-spacing: -0.075em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master_card",
    transform: "translate(-1390.494 -5149.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_327",
    "data-name": "Shape 327",
    className: "cls-1",
    d: "M1418.159,4889.874h34.973a1.7,1.7,0,0,1,1.665,1.734v21.674a1.7,1.7,0,0,1-1.665,1.734h-34.973a1.7,1.7,0,0,1-1.665-1.734v-21.674A1.7,1.7,0,0,1,1418.159,4889.874Z",
    transform: "translate(-26 260)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_329",
    "data-name": "Shape 329",
    className: "cls-2",
    d: "M1433.249,4902.441a8.979,8.979,0,1,1,8.98,8.981,8.98,8.98,0,0,1-8.98-8.981Z",
    transform: "translate(-26 260)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_329-2",
    "data-name": "Shape 329",
    className: "cls-3",
    d: "M1428.47,4911.42a8.98,8.98,0,1,1,7.191-14.36h-1.2v.6h1.613c.121.191.235.389.341.589h-2.554v.6h2.843c.088.2.167.4.237.6h-3.68v.6h3.868a9.033,9.033,0,0,1-.192,5.389h-3.676v.6h3.439c-.09.207-.187.4-.285.591h-2.554v.6h2.206c-.133.21-.272.411-.413.6h-1.193v.6h.7A8.993,8.993,0,0,1,1428.47,4911.42Z",
    transform: "translate(-26 260)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "MasterCard",
    className: "cls-4",
    transform: "translate(1392.177 5164.036) rotate(7.313)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MasterCard")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master_card.bbe22694f722df4c5025a57c8ca4845d.svg";
export { ForwardRef as ReactComponent };